const $ = require('jquery');

/**
 * Adjusts the position of the modal container based on the window size
 */
const adjustModalContainerPosition = () => {
    const $modalContainer = $('.product-try-on__modal');

    if (!$modalContainer.length) {
        return;
    }

    const BREAK_POINT_MOBILE = 1200;
    const isMobile = window.innerWidth < BREAK_POINT_MOBILE;
    const targetContainer = isMobile ? '.product-images .product-images-top' : 'body';

    if (!$modalContainer.parent().is(targetContainer)) {
        $(targetContainer).append($modalContainer);
    }

    const $closeButton = $modalContainer.find('.product-try-on__close-button');
    const iconClass = isMobile ? 'icon-arrow_left2' : 'icon-close_2';

    $closeButton.find('i').attr('class', iconClass);
    $closeButton.trigger('focus');
};

/**
 * Creates the modal container and displays it when the corresponding button is clicked
 *
 * @param {Object} $tryOnButton - jquery button that triggers the modal
 * @param {string} iconClass - Class name of the close button icon
 * @param {string} appendTo - Selector of the element where the modal will be appended
 */
const createModalContainer = ($tryOnButton, iconClass, appendTo) => {
    if (!$tryOnButton.length || !$tryOnButton.data('3d-product-model-url')) {
        return;
    }

    toggleAriaHidden();

    const productModelUrl = $tryOnButton.data('3d-product-model-url');
    const $modal = $('<div>', {
        class: 'product-try-on__modal',
        role: 'dialog',
        id: 'wanna-product-try-on',
        'aria-modal': 'true',
        'aria-label': $tryOnButton.data('aria-label')
    });
    const $container = $('<div>', {
        class: 'product-try-on__container',
        tabindex: 0
    });
    const wannaIframeConfig = {
        class: 'js-wanna-iframe',
        src: productModelUrl,
        allow: 'camera',
        scrolling: 'no',
        'aria-label': $tryOnButton.data('iframe-aria-label')
    };
    const $iframe = $('<iframe>', wannaIframeConfig);
    const $closeButton = $('<button>', {
        class: 'js-product-try-on-close product-try-on__close-button',
        'aria-label': $tryOnButton.data('back-button-aria-label')
    });
    const $icon = $('<i>', {
        class: iconClass,
        'aria-label': $tryOnButton.data('back-button-aria-label')
    });

    $closeButton.append($icon);
    $container.append($closeButton, $iframe);
    $modal.append($container);
    $(appendTo).append($modal);

    $tryOnButton.attr('aria-controls', 'wanna-product-try-on');

    adjustModalContainerPosition();
    $closeButton.trigger('focus');
};

/**
 * Function that toggles aria-hidden property of background elements on or off
 *
 */
function toggleAriaHidden() {
    let isAriaHidden = true;
    const focusableEls = $('.product-images-top')
        .find('a, button, input, select, textarea, .share-button')
        .not('.slick-slide')
        .toArray();
    focusableEls.forEach(item => {
        if ($(item).attr('aria-hidden')) {
            /** If true, set to false. If false, set to true. */
            isAriaHidden = $(item).attr('aria-hidden') === 'false';
        }
        $(item).attr('aria-hidden', isAriaHidden);
    });
}

/**
 * Function to set tabindex of elements to -1 or 0
 *
 * @param {boolean} isTabNavigationAllowed - whether to allow tab navigation or not
 */
function allowTabNavigation(isTabNavigationAllowed) {
    if (isTabNavigationAllowed) {
        /**
         * Re-set tabindex to 0 on all elements that are accessible through tab on page landing.
         * These include zoom icons, first image's link, prev and next arrows and try on btn.
         */

        const tabArray = $(document)
            .find(
                'a:not(.slick-carousel-container a), button:not(.slick-carousel-container button), .zoom-icon, .share-button, .slick-slide a:first, select, textarea'
            )
            .toArray();
        tabArray.forEach(item => {
            $(item).attr('tabindex', 0);
        });
    } else {
        const tabArray = $(document)
            .find(
                'a, button:not(.js-product-try-on-close), input, select, textarea, .share-button, textarea, [tabindex]:not([tabindex="-1"])'
            )
            .not('.product-try-on__modal *')
            .toArray();
        tabArray.forEach(item => {
            $(item).attr('tabindex', -1);
        });
    }
}

/**
 * Function to control logic that hides VTO modal
 */
function hideModal() {
    $('.product-try-on__modal').hide().attr('aria-hidden', 'true').removeAttr('aria-modal');
    toggleAriaHidden();
    allowTabNavigation(true);
    // bring focus back in case screen reader changes it
    $('.js-try-on-button').trigger('focus');
}

/**
 * Module for "Try On AR" functionality
 *
 * @namespace tryOnAR
 */
const tryOnAR = {
    /**
     * Initializes the "Try On AR" module
     *
     * @function init
     */
    init: () => {
        $(document).on('click', '.js-product-try-on-desktop', function () {
            if ($('.product-try-on__modal') && $('.product-try-on__modal').length) {
                $('.product-try-on__modal').show().attr('aria-hidden', 'false').attr('aria-modal', 'true');
                $('.js-product-try-on-close').trigger('focus');
            } else {
                createModalContainer($(this), 'icon-close_2', 'body');
            }
            allowTabNavigation(false);
            $(this).attr('aria-controls', 'wanna-product-try-on');
        });

        $(document).on('click', '.js-product-try-on-mobile', function () {
            if ($('.product-try-on__modal') && $('.product-try-on__modal').length) {
                $('.product-try-on__modal').show().attr('aria-hidden', 'false').attr('aria-modal', 'true');
            } else {
                createModalContainer($(this), 'icon-arrow_left2', '.product-images .product-images-top');
            }
            $('.js-product-try-on-close').trigger('focus');
            allowTabNavigation(false);
        });

        $(document).on('click', '.js-product-try-on-close', function () {
            const $tryOnButton = $('.js-try-on-button');
            $tryOnButton.removeAttr('aria-controls');
            hideModal();
        });

        $(document).on('keydown', '.product-try-on__modal', function (event) {
            if (event.key === 'Escape') {
                hideModal();
            }
        });
    }
};

exports.init = tryOnAR.init;
